import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

import VueResource from 'vue-resource'
import router from './router'

import Notifications from 'vue-notification'

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(Notifications)

const baseUrl = 'https://corp-api.3ms.app'

Vue.http.interceptors.push((request, next) => {
  if (!request.url.startsWith('http')) request.url = baseUrl + request.url

  request.headers.set('Authorization', 'Bearer ' + localStorage.getItem('jwt'))

  next()
})

const jwt = localStorage.getItem('jwt')

if (!jwt || jwt.length === 0) {
  console.log('Redirecting to login...')
  router.push('/login')
} else
  router.push('/list')

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
